'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildPublishFailedMessage = undefined;

var _PubNubMessageStatusTypes = require('../../constants/PubNubMessageStatusTypes');

var _buildMessageWithStatus = require('./buildMessageWithStatus');

var buildPublishFailedMessage = exports.buildPublishFailedMessage = (0, _buildMessageWithStatus.buildMessageWithStatus)(_PubNubMessageStatusTypes.PUBLISH_FAILED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/PubNubMessageFactory/buildPublishFailedMessage.js
// module id = 586
// module chunks = 2 3